/**
 * @generated SignedSource<<2766de5eaa88f9bdf423d5a7936f6146>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmploymentContractsType = "all" | "blank" | "none" | "some";
export type employmentContractsQuery$variables = {
  refundHistoryId: string;
};
export type employmentContractsQuery$data = {
  readonly getSurveyEmploymentAnswer: {
    readonly employmentAnswer: {
      readonly hasEmploymentContracts: EmploymentContractsType | null | undefined;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type employmentContractsQuery = {
  response: employmentContractsQuery$data;
  variables: employmentContractsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundHistoryId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyEmploymentAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyEmploymentAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyEmploymentAnswer",
        "kind": "LinkedField",
        "name": "employmentAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasEmploymentContracts",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "employmentContractsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "employmentContractsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "413369b072e189961c0ade3d86b4805e",
    "id": null,
    "metadata": {},
    "name": "employmentContractsQuery",
    "operationKind": "query",
    "text": "query employmentContractsQuery(\n  $refundHistoryId: String!\n) {\n  getSurveyEmploymentAnswer(refundHistoryId: $refundHistoryId) {\n    result\n    employmentAnswer {\n      hasEmploymentContracts\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac6c4debc573b01ba9d3958a0c0acb5d";

export default node;
